module.exports = __webpack_public_path__ + "static/img/btn_pagetop.2023a07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_pagetop.svg
// module id = 100
// module chunks = 0